<template>
    <div class="container">
    <div class="row justify-content-between align-items-center pad-row">
        <h3 class="numbers">Members <span>({{ getMembersCount }})</span></h3>
        <form class="search-input">
            <input
                id="search"
                class="form-control"
                type="search"
                placeholder="Search"
                autocomplete="off"
                v-model="searchQuery"
            >
            <button type="button"><i class="fa fa-search"></i></button>
        </form>
    </div>

    <MembersList
        v-if="getMembersCount"
        :inner_members="getMembersFilteredList"
        :user_is_active="input_active"
    >
    </MembersList>
    <h4 class="mt-5" v-else>No results found!</h4>

    <div class="text-center" v-if="getMembersFilteredList.length && members.next_page_url">
        <button class="btn-more" @click="loadMore">Show more</button>
    </div>
</div>
</template>

<script>
    import MembersList from "./MembersList";

    export default {
        name: "MembersContainer",
        components: {
            MembersList
        },
        props: {
            input_members: Object,
            input_active: Boolean
        },
        data() {
            return {
                members: this.input_members,
                searchQuery: null
            }
        },
        computed: {
            getMembersCount() {
                return this.getMembersFilteredList.length
            },
            getMembersFilteredList() {
                if (this.searchQuery) {
                    const includesIgnoreCase = (value) =>
                            value.toLowerCase().includes(this.searchQuery.toLowerCase());

                    return this.members.data.filter(member => {
                        return (
                            includesIgnoreCase(member.first_name) ||
                            includesIgnoreCase(member.last_name) ||
                            includesIgnoreCase(member.company_name) ||
                            includesIgnoreCase(member.generation)
                        )
                    })
                } else {
                    return this.members.data;
                }
            }
        },
        methods: {
            loadMore() {
                if (this.members.next_page_url) {
                    axios.post(`/members`, {page: this.members.current_page + 1})
                        .then(response => {
                            let new_members = response.data.members;
                            let old_list = this.members.data;
                            let new_list = response.data.members.data;

                            new_members.data = old_list.concat(new_list);
                            this.members = new_members;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }
</style>
